import { Component, Input, OnInit } from "@angular/core";
import { SharedService } from "app/services/core/shared.service";
import { LabService } from "app/services/lab/lab.service";


@Component({
  selector: 'app-associated',
  templateUrl: './associated.component.html'
})

export class AssociatedComponent implements OnInit {
  @Input() stateNumber: string = '';
  public associatedTab = 0;

  constructor(public labService: LabService,
    public sharedService: SharedService) {};

  ngOnInit(): void {
    this.associatedTab = 0;
    this.labService.associatedTab = 0;
  }

  tabVisible(type: string): boolean {
    // TODO
    return true;
  }

}
